module.exports = __webpack_public_path__ + "img/banner_detail_2.3d08cc2b.png";